import React, {useState, useEffect, useRef} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as DesignerFunctions from '../utilities/DesignerFunctions';
import * as Teleport from '../utilities/Teleport';
import * as ActionModifiers from '../ActionModifiers';
import * as GuideMessaging from './GuideMessaging';
import TabTemplates from '../Tabs/TabTemplates';
import TabElements from '../Tabs/TabElements';
import TabUserDefinitions from '../Tabs/TabUserDefinitions';
// import TabDatabases from '../Tabs/TabDatabases';
import TabContracts from '../Tabs/TabContracts';
import TabColors from '../Tabs/TabColors';
import TabNavigator from '../Tabs/TabNavigator';
import TabOverallStyles from '../Tabs/TabOverallStyles';
import TabElementStyles from '../Tabs/TabElementStyles';
import LeftTabs from '../LeftTabs';
import NormalIcon from '../StockItems/NormalIcon';
import MainEditScreenPiece from './MainEditScreenPiece';

function App(props) {

  var width = props.width;
  var height = props.height;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;

  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var error = props.error;
  var addToExtraScreen = props.addToExtraScreen;

  var editAreaHeight = height;
  var tabSelected = props.tabSelected;
  var setTabSelected = props.setTabSelected;
  var changeTab = props.changeTab;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;

  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var programSetID = props.programSetID;
  var logInState = props.logInState;
  var screenSize = props.screenSize;

  var mostRecentFont = props.mostRecentFont;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentFont = props.setMostRecentFont;
  var setMostRecentColor = props.setMostRecentColor;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;

  var setItemEdited = props.setItemEdited;
  var itemEdited = props.itemEdited;

  var refObject = props.refObject;
  var setRefObject = props.setRefObject;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;

  var zoom = props.zoom;
  var resetZoom = props.resetZoom;
  var translateX = props.translateX;
  var translateY = props.translateY;
  var setTranslateX = props.setTranslateX;
  var setTranslateY = props.setTranslateY;
  var detailsWidth = props.detailsWidth;
  var setDetailsWidth = props.setDetailsWidth;
  var centerZoom = props.centerZoom;
  var urlParamsForExecution = props.urlParamsForExecution;
  var scrollableElement = props.scrollableElement;
  var tempAddr = props.tempAddr;
  var setTempAddr = props.setTempAddr;

  var tabWidth = props.tabWidth;
  var heightsOfPages = props.heightsOfPages;
  var setHeightsOfPages = props.setHeightsOfPages;
  var chains = props.chains;
  var palette = props.palette;
  var itemCategories = props.itemCategories;

  var urlHeader = 'https://www.cues.sg/dapps/XXXX';
  
  const [addWhichItem, setAddWhichItem] = useState(false);
  const [otherInfo, setOtherInfo] = useState({});
  const [movementOffset, setMovementOffset] = useState(0);

  const [toggle, setToggle] = useState(0);
  const [timeToggle, setTimeToggle] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [screenRefs, setScreenRefs] = useState({});
  const [leftColRefs, setLeftColRefs] = useState({});
  const [screenSelectionChoices, setScreenSelectionChoices] = useState({});
  const [addLoc, setAddLoc] = useState(0);
  const [flashHighlight, setFlashHighlight] = useState(false);
  const [baselineMousePosition, setBaselineMousePosition] = useState(false);
  const [lastEdited, setLastEdited] = useState('');

  var pageRef = useRef();
  var detailsRef1 = useRef();
  var detailsRef2 = useRef();

  var currentListX = currentList;

  const [colorCombo, setColorCombo] = useState(0);
  const [counter, setCounter] = useState(0);
  var cust = ActionModifiers.createNull();  
  const [customColorRecord, setCustomColorRecord] = useState(cust);
  const [isShowingCustom, setIsShowingCustom] = useState(false);


  var modOptions = [];

  if (tabSelected && tabSelected.t === 'Colors'){
    if (tabSelected.s === 1){
      currentListX = JSON.parse(JSON.stringify(currentList));
      var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);
      modOptions = ActionModifiers.findIssues(currentListX, components, 'selectNew', chains, changeTab);
    }
  }

  function incrementCounter(){
    setCounter(counter + 1);
  }

  var fe = currentListX.fe;
  var feKeys = Object.keys(fe);

  function onMouseUp(e){
    setBaselineMousePosition(false);
  }

  var ssSizes = StyleFunctions.screenWidthsAndHeights(screenSize);
  var insetWidth = ssSizes.insetWidth;
  var insetHeight = ssSizes.insetHeight;

  var scale = Math.pow(10, zoom * 0.1);

  useEffect(()=>{

    var startFEKey = '';
    if (feKeys.length > 0){
      startFEKey = feKeys[0];
    }

    var startEdit = false;
    var screens = {};
    var thisFE4 = CoreFns.goDownPath(currentListX, ['fe', startFEKey]);
    if (thisFE4){
      screens = thisFE4._s;
    }
    var screenKeys = CoreFns.sortedKeyList(screens);

    if (screenKeys.length > 0){
      startEdit = {t:'page', path:['fe', startFEKey]};
    }
    setItemEdited(startEdit);

    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mouseup', onMouseUp, false);
    };

  }, []); // eslint-disable-line react-hooks/exhaustive-deps



  function calcAddPos(){
    var xPos = 0;
    var addPos = [];
    var sortedFeKeys = CoreFns.sortedKeyList(fe);
    sortedFeKeys.forEach((anFEKey, index)=>{
      var thisFE1 = fe[anFEKey];
      if (!thisFE1.pos){
        addPos.push({t:'w',w:['fe', anFEKey, 'pos'],n:{xP:xPos, yP:0}});
        xPos += 1;
      }else{
        if (xPos < thisFE1.pos.xP){
          xPos = thisFE1.pos.xP;
        }
      }
    })

    var pu = currentListX.pu;

    var sortedPuKeys = CoreFns.sortedKeyList(pu);
    sortedPuKeys.forEach((anPUKey, index)=>{
      var thisPU = pu[anPUKey];
      if (!thisPU.pos){
        addPos.push({t:'w',w:['pu', anPUKey, 'pos'],n:{xP:xPos, yP:0}});
        xPos += 1;
      }else{
        if (xPos < thisPU.pos.xP){
          xPos = thisPU.pos.xP;
        }
      }
    })
    return addPos;    
  }



  function updateLocation(addPos){ //this is a temporary fix.
    if (addPos.length > 0){
      organicChanges(addPos);
    }        
  }

  useEffect(()=>{
    var addPos = calcAddPos();
    if (addPos.length > 0){
      var vv = width - tabWidth - detailsWidth - 35;
      setTranslateY(10);
      setTranslateX(vv/2)
      setTimeout(function(){ updateLocation(addPos); }, 1);      
    }else{
      resetZoom(screenSize);
    }
  }, [width]);


  useEffect(()=>{
    toggleTime(0);
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };


    // CoreFns.clearSelection();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };

    // CoreFns.clearSelection();
  }, [itemEdited]); 

  if (!currentListX){
    return <div>Loading...</div>
  }
//  


  function toggleTime(t){
    setTimeToggle(t);
    setTimeout(function(){ toggleTime(1 - t); }, 1000);
  }

  var thisItem = false;
  var screenKeys = []
  var screens = {};
  if (itemEdited){
    try{
      thisItem = CoreFns.goDownPath(currentListX, itemEdited.path);
    }catch(err){
    }

    if (itemEdited.t === 'asset'){
      try{
        var thisFE2 = CoreFns.goDownPath(currentListX, [itemEdited.screenPath[0], itemEdited.screenPath[1]]);
        screens = thisFE2._s;
        screenKeys = CoreFns.sortedKeyList(screens);
      }catch(err){
        console.log(itemEdited);
      }

    }else{
      if (itemEdited.path[0] === 'cn' || itemEdited.path[0] === 'fo'){

      }else{
        try{
          var thisFE3 = CoreFns.goDownPath(currentListX, [itemEdited.path[0], itemEdited.path[1]]);
          screens = thisFE3._s;
          screenKeys = CoreFns.sortedKeyList(screens);
        }catch(err){
          console.log(itemEdited);
        }        
      }
    }    
  }



  function removeItemFn(e){

    if (thisItem){
      if (itemEdited.t === 'page'){
        setItemEdited(false);
        var changes4 = [{t:'r',w:[itemEdited.path[0]],i:itemEdited.path[1]}];
        organicChanges(changes4);
      }else if (itemEdited.t === 'screen'){
        if (itemEdited.path[0] === 'fo'){
          var changes3 = [{t:'w',w:['fo','on'],n:0}];
          setItemEdited(false);
          organicChanges(changes3);
        }else{
          var nextScreen;
          var aScreenKey = itemEdited.path[3];
          var screenPath = [itemEdited.path[0], itemEdited.path[1], '_s'];


          var index = 0;
          for (var i = 0; i < screenKeys.length; i++){
            if (screenKeys[i] === aScreenKey){
              index = i;
              break;
            }
          }

          if (index === screenKeys.length - 1){
            if (index > 0){
              nextScreen = screenKeys[index - 1];
            }
          }else{
            nextScreen = screenKeys[index + 1];
          }

          if (nextScreen){
            setItemEdited({t:'screen', path:screenPath.concat([nextScreen])})        
          }else{
            setItemEdited({t:'page', path:[itemEdited.path[0], itemEdited.path[1]]});
          }
          var changes1 = [{t:'r',w:screenPath,i:aScreenKey}];
          organicChanges(changes1);

        }
      }else if (itemEdited.t === 'asset'){
        var element = getElementFromEntity(itemEdited.path[1]);
        element.parentNode.removeChild(element);
        var path = itemEdited.screenPath;
        var ref2 = refObject[path.join('_')];
        var doInputActions2 = ResponsiveFns.doInputActionsFn(path, organicChanges, currentListX, userID);
        doInputActions2(ref2);
        setItemEdited({t:'item',path});
      }else if (itemEdited.t === 'navBar'){
        var path5 = itemEdited.path;
        setItemEdited({t:'page', path:[itemEdited.path[0], itemEdited.path[1]]});
        organicChanges([{t:'w',w:path5.concat(['on']),n:0}]);
      }else{
        var p = itemEdited.path;
        var p1 = ResponsiveFns.stripOffLastItem(p);
        var newClicked;
        if (itemEdited.t === 'item'){
          if (EditorFunctions.isNavPath(itemEdited.path)){
            newClicked = {t:'navBar', path:CoreFns.filterPathStopBefore(p, 3)};
          }else if (p.length === 6 && (p[0] === 'fe' || p[0] === 'pu')){
            newClicked = {t:'screen', path:CoreFns.filterPathStopBefore(p, 4)};
          }else if (p.length === 3 && p[0] === 'fo'){
            newClicked = {t:'screen', path:CoreFns.filterPathStopBefore(p, 1)};
          }else{
            var itemScreenPath1 = CoreFns.filterPathStopBefore(p, p.length - 2);
            if (CoreFns.isAlert(itemScreenPath1)){
              newClicked = {t:'alert', path:itemScreenPath1};
            }else{
              newClicked = {t:'item', path:itemScreenPath1};
            }
          }
        }else if (itemEdited.t === 'alert'){
          newClicked = {t:'screen', path:CoreFns.filterPathStopBefore(p, 4)}        
        }
        if (newClicked){
          setItemEdited(newClicked);
        }      
        var changes = [{t:'r',w:p1.priors,i:p1.last}];
        organicChanges(changes);
      }
      
    }

    if (e){
      e.stopPropagation();

    }
  }

  function escFunction(event){
    if (event.key === 'Backspace'){
      if( event.target.nodeName === "INPUT" || event.target.nodeName === "TEXTAREA" ) return;
      if( event.target.isContentEditable ) return;
        removeItemFn();
    } 

  }

//  
  var onClickItemChangeSelection = StyleFunctions.onClickItemChangeSelectionFn(setItemEdited, setIsShowingSomeDropDown);

  const selectedColor = '#444';

  var overallError = false;
  if (error && error.loc){
    var loc = error.loc;
      if (loc[0] === 'oc'){
        overallError = true;
      }    
  }

  var editElementName = DesignerFunctions.itemN(thisItem, itemEdited);
  var addElementName = 'Item';
  if (thisItem){
  }else{
    addElementName = 'Page';
  }

  var elementPieces = [];
  if (feKeys.length > 0){
    elementPieces = [{t:'Overall', n:'Overall', a:'clarity:design-line', e:overallError}, {t:'ElementStyle', n:editElementName, a:'ion:shapes-outline'}, {t:'AddElement', n:'Add ' + addElementName, a:'material-symbols:add'}, {t:'Navigator', n:'Navigator', a:'et:compass'}, {t:'Definitions', n:'Definitions', a:'arcticons:dictionary'}, {t:'Contracts', n:'Contracts', a:'clarity:contract-line'}, {t:'Colors', n:'Colors', a:'bi:palette'}];
    if (CoreFns.isAdmin(logInState)){
      // elementPieces.push({t:'Databases', n:'Databases', a:'ph:database-bold'});
      elementPieces.push({t:'For Sam', n:'For Sam', a:'carbon:template'});
    }
  }

  function clickTab(element, index){
    return function(e){
      changeTab(element.t, 0);
    }
  }
  function clickTabSelectNone(e){
    setTabSelected(false);
    setIsShowingSomeDropDown(false);
  }

//
  var tabDetails0;

  var fakeInternalVariables = {otherInfo, setOtherInfo};

  var editButtons = EditorFunctions.allEditButtons(chains, setIsShowingSomeDropDown, isShowingSomeDropDown, itemEdited, currentListX, organicChanges, refObject, toggle, setToggle, setItemEdited, insetWidth, insetHeight, onClickItemChangeSelection, userNos, userID, isClickingOnContentDiv, logInState, removeItemFn, tabSelected, hidePanelRelativeItems, setHidePanelRelativeItems, addToExtraScreen, changeTab, otherInfo, setOtherInfo, urlParamsForExecution, urlHeader, centerZoom);

  var tgtDropDown = '';
  if (isShowingSomeDropDown){
    for (var i4 = 0; i4 < editButtons.length; i4++){
      if (editButtons[i4].h === isShowingSomeDropDown.t){
        tgtDropDown = editButtons[i4];
      }
    }
  }

  var errorOrPromptLine = null;
  var highlightAnItem = false;

  if (error && error.loc){
    function goError(e){
      Teleport.goToLocation(error.screenPath, error.loc, null, changeTab, setIsShowingSomeDropDown, setItemEdited, screenRefs, leftColRefs, flashHighlight, setFlashHighlight, 'red', currentListX, centerZoom, fakeInternalVariables);
    }

    var errorIn = '[Go to Error]';
    if (error.loc.join(' ') === 'noDefaultScreen'){
      errorIn = '[Highlight Error]';
    }
    var errorX = <span onClick={goError} className='selectText' style={{cursor:'pointer'}}>{errorIn}</span>
//
    errorOrPromptLine = <div style={{color:'red', paddingLeft:'10px'}}>{error.t} {errorX}</div>
//
  }else{
    var p = ActionModifiers.actionMods(currentListX, [], 'placeholder', chains, changeTab);
    if (p.length > 0){

      function goPlace(e){
        Teleport.goToLocation(p[0].screenPath, p[0].path, null, changeTab, setIsShowingSomeDropDown, setItemEdited, screenRefs, leftColRefs, flashHighlight, setFlashHighlight, 'orange', currentListX, centerZoom, fakeInternalVariables);
      }

      errorOrPromptLine = <div style={{color:'orange', paddingLeft:'10px'}}>{p[0].n} <span onClick={goPlace} className='selectText' style={{cursor:'pointer'}}>[Go to Placeholder]</span></div>

    }else if (doingWhat && doingWhat.t === 'guide'){

      var msgSet = GuideMessaging.getMessage(doingWhat, itemEdited, currentListX, screenKeys, tabSelected, isShowingSomeDropDown, tgtDropDown);
      var msg = msgSet.message;
      highlightAnItem = msgSet.highlightAnItem;

      function skipTutorial(e){
        setDoingWhat(false);
      }
      errorOrPromptLine = <div style={{color:'yellow', paddingLeft:'10px'}}>Tutorial {doingWhat.v + 1}/5: {msg} <span onClick={skipTutorial} className='selectText' style={{cursor:'pointer'}}>[Skip Tutorial]</span></div>
//
    }else{

      function goContracts(e){
        changeTab('Contracts', 0);
      }

      var sc = currentListX.sc;
      var scKeys = Object.keys(sc);
      var p1 = scKeys.filter((aScKey, index)=>{
        if (sc[aScKey].template){
          return true;
        }
        return false;
      })
//
      if (p1.length > 0){
        errorOrPromptLine = <div style={{color:'orange', paddingLeft:'10px'}}>Contracts are those provided by the template and have not been modified <span onClick={goContracts} className='selectText' style={{cursor:'pointer'}}>[Go to Contracts]</span></div>
      }
    }
  }
//
  if (timeToggle){
    highlightAnItem = false;
  }
//
  var tabSelectedIndex = -2;
  for (var i = 0; i < elementPieces.length; i++){
    if (elementPieces[i].t === tabSelected.t){
      tabSelectedIndex = +i;
    }
  }
  var elementRows = elementPieces.map((anElement, index)=>{
    return <LeftTabs key={index} index={index} anElement={anElement} tabWidth={tabWidth} clickTab={clickTab} highlightAnItem={highlightAnItem} tabSelectedIndex={tabSelectedIndex} />
  })
//

  function addItem(item, addPath, position){
    var uuid = CoreFns.uuidCheckEverywhere(userNos, currentListX);
    return ResponsiveFns.reallyAddItem(item, addPath, uuid, position, currentListX, organicChanges, [], setItemEdited, insetWidth, insetHeight, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems)
  }

  function addPanel(p0, p1){
    return function(e){
      var alertPath = [p0, p1, '_s']
      addToExtraScreen({t:'categorySelector', itemT:'PANEL', position:'notUsed', insetWidth, insetHeight, addPath:alertPath});
      e.stopPropagation();
    }
  }

  function addFE(isFEOrPU){
    return function(e){
      addToExtraScreen({t:'categorySelector', itemT:isFEOrPU, insetWidth, insetHeight})      
    }
  }  

  if (tabSelected && tabSelectedIndex > -2){
    var isNavEdited = false;

    if (itemEdited){
      if (itemEdited.t === 'screen' || itemEdited.t === 'item' || itemEdited.t === 'alert'){
        if (itemEdited.path[2] === 'nv'){
          isNavEdited = true;
        }
      }else if (itemEdited.t === 'asset'){
      }else if (itemEdited.t === 'navBar'){
        isNavEdited = true;
      }
    }

    var tabContents;

    var addWhereText = '';
    var potentiallyAddWhichItem = false;
    var addPath = [];

    function onDragStart(e){
      setMovementOffset(e.clientX);
    }

    function onDrag(e){
    }

    function onDragEnd(e){
      var newWidth = detailsWidth + e.clientX - movementOffset;
      if (newWidth < tabWidth + 20){
        newWidth = tabWidth + 20;
      }
      setDetailsWidth(newWidth);
    }

    var dragPiece = <div style={{position:'absolute', right:1, top:0, bottom:0, width:2, cursor:'ew-resize'}} draggable={true} onDragStart={onDragStart} onDrag={onDrag} onDragEnd={onDragEnd} ></div>
//
    var botStyle = {height:editAreaHeight, width:detailsWidth - 20, paddingBottom:'20px', overflowX:'scroll', overflowY:'scroll'}
    var b1Style = {width:detailsWidth, backgroundColor:'white', verticalAlign:'top', position:'relative', zIndex:1};

//
    if (tabSelected.t === 'Overall'){
      tabContents = <TabOverallStyles chains={chains} currentList={currentListX} organicChanges={organicChanges} detailsWidth={detailsWidth} error={error} addToExtraScreen={addToExtraScreen} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} changeTab={changeTab} tabSelected={tabSelected} userNos={userNos} doingWhat={doingWhat} setDoingWhat={setDoingWhat} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>
    }else if (tabSelected.t === 'Definitions'){
      tabContents = <TabUserDefinitions addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} currentList={currentListX} error={error} userNos={userNos} changeTab={changeTab} tabSelected={tabSelected} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} />
    // }else if (tabSelected.t === 'Databases'){
    //   tabContents = <TabDatabases addToExtraScreen={addToExtraScreen} changeTab={changeTab} tabSelected={tabSelected} userID={userID} sessionID={sessionID} signKey={signKey} programSetID={programSetID} />
    }else if (tabSelected.t === 'For Sam'){

      var offsetTop1 = 0;
      var offsetLeft1 = 0;
      if (pageRef && pageRef.current){
       offsetTop1 = pageRef.current.offsetTop;
      }

      if (detailsRef1 && detailsRef1.current){
        offsetLeft1 += detailsRef1.current.offsetLeft;
        // offsetTop1 += detailsRef1.current.offsetTop;
      }
      if (detailsRef2 && detailsRef2.current){
        offsetLeft1 += detailsRef2.current.offsetLeft;
        offsetTop1 += detailsRef2.current.offsetLeft - detailsRef2.current.scrollTop;
      }

      tabContents = <TabTemplates chains={chains} overallWidth={width} insetHeight={insetHeight} insetWidth={insetWidth} currentList={currentListX} detailsWidth={detailsWidth} userID={userID} sessionID={sessionID} signKey={signKey} offsetTop={offsetTop1} offsetLeft={offsetLeft1} itemEdited={itemEdited} changeTab={changeTab} itemCategories={itemCategories}/>
      //
    }else if (tabSelected.t === 'Contracts'){
      tabContents = <TabContracts chains={chains} organicChanges={organicChanges} currentList={currentListX} signKey={signKey} userID={userID} logInState={logInState} sessionID={sessionID} userNos={userNos} addToExtraScreen={addToExtraScreen} tempAddr={tempAddr} setTempAddr={setTempAddr}/>

    }else if (tabSelected.t === 'Navigator'){

      tabContents = <TabNavigator chains={chains} currentList={currentListX} error={error} setItemEdited={setItemEdited} setIsShowingSomeDropDown={setIsShowingSomeDropDown} itemEdited={itemEdited} userNos={userNos} organicChanges={organicChanges} highlightAnItem={highlightAnItem} screenRefs={screenRefs} leftColRefs={leftColRefs} flashHighlight={flashHighlight} setFlashHighlight={setFlashHighlight} addToExtraScreen={addToExtraScreen} centerZoom={centerZoom} fakeInternalVariables={fakeInternalVariables} changeTab={changeTab}/>

    }else if (tabSelected.t === 'ElementStyle'){

      tabContents = <TabElementStyles chains={chains} currentList={currentListX} error={error} itemEdited={itemEdited} setItemEdited={setItemEdited} insetWidth={insetWidth} insetHeight={insetHeight} setIsShowingSomeDropDown={setIsShowingSomeDropDown} userNos={userNos} userID={userID} organicChanges={organicChanges} highlightAnItem={highlightAnItem} addToExtraScreen={addToExtraScreen} isShowingSomeDropDown={isShowingSomeDropDown} doingWhat={doingWhat} setDoingWhat={setDoingWhat} changeTab={changeTab} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs} flashHighlight={flashHighlight} setFlashHighlight={setFlashHighlight} isClickingOnContentDiv={isClickingOnContentDiv} logInState={logInState} sessionID={sessionID} signKey={signKey} screenRefs={screenRefs} detailsWidth={detailsWidth} refObject={refObject} toggle={toggle} setToggle={setToggle} screenSize={screenSize} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} editButtons={editButtons} centerZoom={centerZoom} fakeInternalVariables={fakeInternalVariables} setLastEdited={setLastEdited}/>

// //
//
    }else if (tabSelected.t === 'AddElement'){

      function getSet(path, addLocHere){
        if (path[0] === 'fo'){
          return {aW:'FOOTER', aP:['fo', 'k']}
        }else if (path[0] === 'fe' || path[0] === 'pu'){
          if (screens[path[3]]){
            var last = 'k';
            if (addLocHere === 1){
              last = 'i';
            }
            return {aW:'PANEL', aP:[path[0], path[1], '_s', path[3], last]}
          }else if (path[0] === 'fe'){
            return {aW:'Page', aP:[]}
          }else if (path[0] === 'pu'){
            return {aW:'Pop-Up', aP:[]}
          }
        }
      }

      var addNext = false;
      if (itemEdited.t === 'screen'){
        var set1 = getSet(itemEdited.path, addLoc);
        addWhereText = set1.aW;
        addPath = set1.aP;
      }else if (itemEdited.t === 'asset'){
        var set2 = getSet(itemEdited.screenPath, 0);
        addWhereText = set2.aW;
        addNext = true;
        addPath = set2.aP;

      }else if (itemEdited && itemEdited.t === 'item'){
        if (thisItem){
          if (isNavEdited){
            addWhereText = 'navBar';
            addPath = [itemEdited.path[0], itemEdited.path[1], 'nv', 'i']
          }

          if (CoreFns.isHolder(thisItem.t)){
            addPath = itemEdited.path.concat(['i']);
            addWhereText = ResponsiveFns.addWhereFromItem(thisItem, addWhereText);
          }else{
            if (StyleFunctions.isFirstLevel(itemEdited.path)){
              var set3 = getSet(itemEdited.path, addLoc);
              addWhereText = set3.aW;
              addPath = set3.aP;
            }else{
              addNext = true;
              var p66 = ResponsiveFns.stripOffLastItem(itemEdited.path);                  
              addPath = p66.priors;
              var parentItem = CoreFns.goDownPath(currentListX, itemEdited.path, 2);
              addWhereText = ResponsiveFns.addWhereFromItem(parentItem, addWhereText);
            }
          }                
        }

      }else if (itemEdited && itemEdited.t === 'navBar'){
        addPath = itemEdited.path.concat(['i']);
        addWhereText = 'navBar';
      }else if (itemEdited && itemEdited.t === 'alert'){
        addPath = itemEdited.path.concat(['k']);
        addNext = true;
        addWhereText = 'ALERT';
      }else{
        addWhereText = 'Page';
      }

      if (addLoc === 0){
        potentiallyAddWhichItem = addWhichItem;
      }


      tabContents = <TabElements thisItem={thisItem} addItem={addItem} insetWidth={insetWidth} insetHeight={insetHeight} addPanel={addPanel} organicChanges={organicChanges} setItemEdited={setItemEdited} addToExtraScreen={addToExtraScreen} addPath={addPath} addWhereText={addWhereText} currentList={currentListX} setAddWhichItem={setAddWhichItem} addWhichItem={addWhichItem} highlightAnItem={highlightAnItem} logInState={logInState} addLoc={addLoc} setAddLoc={setAddLoc} isShowingSomeDropDown={isShowingSomeDropDown} error={error} itemEdited={itemEdited} addNext={addNext} addFE={addFE} />

    }else if (tabSelected.t === 'Colors'){
      tabContents = <TabColors currentList={currentListX} organicChanges={organicChanges} addToExtraScreen={addToExtraScreen} palette={palette} changeTab={changeTab} tabSelected={tabSelected} modOptions={modOptions} colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter} customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} counter={counter} height={editAreaHeight} chains={chains}/>
    }


    botStyle.height = editAreaHeight;
    // botStyle.width = detailsWidth - 20; //check this.

    b1Style.backgroundColor = selectedColor;

    tabDetails0 = <td style={b1Style} ref={detailsRef1}>
        <div style={botStyle} ref={detailsRef2}>
          {errorOrPromptLine}
          {tabContents}
        </div>
        {dragPiece}
      </td> 

  }


  function onMouseDownShrink(e){
    e.stopPropagation();
  }

  var removeShrink;

  if (tabSelected && tabSelectedIndex > -2){
    var shrinkStyle = {left:-1, width: 15, top: (editAreaHeight/2 - 50), height:100, position:'absolute', verticalAlign:'middle', textAlign:'center', color:'white', borderCollapse:'collapse', cursor:'pointer', zIndex:1};
    removeShrink = <table style={shrinkStyle} onMouseDown={onMouseDownShrink}><tbody>
          <tr><td style={{verticalAlign:'middle', backgroundColor:selectedColor, borderTopRightRadius:5, borderBottomRightRadius:5}} onClick={clickTabSelectNone}>
          <NormalIcon height={14} icon='ep:arrow-left-bold'/>
          </td></tr>
        </tbody></table>
  }



  // var pi = calcRanges();
  var actDetailsWidth = detailsWidth;
  if (!tabSelected){
    actDetailsWidth = 0;
  }
  var vv = width - tabWidth - actDetailsWidth - 35;

  var hh = -Infinity;
  var hw = -Infinity;

  var offsetTop = 0;
  var offsetLeft = 0;
  if (pageRef && pageRef.current){
    offsetTop += pageRef.current.offsetTop;
    offsetLeft += pageRef.current.offsetLeft;
  }

  if (scrollableElement && scrollableElement.current){
    offsetTop += scrollableElement.current.offsetTop - scrollableElement.current.scrollTop;
    offsetLeft += scrollableElement.current.offsetLeft - scrollableElement.current.scrollLeft;
  }

  function doAFEorPU(feOrPU){
    var x = currentListX[feOrPU];
    var keys = Object.keys(x);
    return keys.map((whichFEOrPUShown, index)=>{

      var thisFE = CoreFns.goDownPath(currentListX, [feOrPU, whichFEOrPUShown]);
      var pos = thisFE.pos;

      var reportPageHeight = false;

      if (feOrPU === 'fe'){
        reportPageHeight = function(h){
          var pushY = 0;
          if (pos){
            pushY = pos.yP * insetHeight * 1.1;
          }
          heightsOfPages[whichFEOrPUShown] = h + pushY;
          setHeightsOfPages(heightsOfPages);
        }
      }

      var thisHeight = heightsOfPages[whichFEOrPUShown];
      if (thisHeight > hh){
        hh = thisHeight;
      }
      var pushX = 0;
      if (pos){
        pushX = pos.xP * insetWidth * 1.1 + (insetWidth / 2);        
      }
      if (pushX > hw){
        hw = pushX;
      }


      return <MainEditScreenPiece key={feOrPU+'_'+index} chains={chains} width={width} height={height} currentList={currentListX} organicChanges={organicChanges} userNos={userNos} userID={userID} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} error={error} tabSelected={tabSelected} changeTab={changeTab} isShowingSomeDropDown={isShowingSomeDropDown} setIsShowingSomeDropDown={setIsShowingSomeDropDown} screenSize={screenSize} setItemEdited={setItemEdited} itemEdited={itemEdited} refObject={refObject} setRefObject={setRefObject} isClickingOnContentDiv={isClickingOnContentDiv} setIsClickingOnContentDiv={setIsClickingOnContentDiv} hidePanelRelativeItems={hidePanelRelativeItems} translateX={translateX} translateY={translateY} otherInfo={otherInfo} setOtherInfo={setOtherInfo} addWhereText={addWhereText} inputValues={inputValues} screenRefs={screenRefs} flashHighlight={flashHighlight} setScreenRefs={setScreenRefs} potentiallyAddWhichItem={potentiallyAddWhichItem} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} setInputValues={setInputValues} highlightAnItem={highlightAnItem} addPanel={addPanel} isFEOrPUShown={feOrPU} whichFEOrPUShown={whichFEOrPUShown} setBaselineMousePosition={setBaselineMousePosition} urlParamsForExecution={urlParamsForExecution} thisFE={thisFE} reportPageHeight={reportPageHeight} scale={scale} offsetLeft={offsetLeft} offsetTop={offsetTop} lastEdited={lastEdited} counter={counter}/>
    })
  }

  var screenPieces = doAFEorPU('fe').concat(doAFEorPU('pu')); 



//

  function clickBackground(e){
    setItemEdited(false)
  }


   var rightStyleOut = {position:'relative', backgroundColor:'#CCC', verticalAlign:'top', overflow:'scroll', zIndex:0, height:editAreaHeight, width:vv};

   var sHeight = hh + editAreaHeight * 0.3/scale + translateY;
   if (sHeight < editAreaHeight * 3 / scale){
    sHeight = editAreaHeight * 3 / scale;
   }

   var sWidth = hw + translateX + vv * 0.3 / scale;
   if (sWidth < vv * 3 / scale){
    sWidth = vv * 3 / scale;
   }

   var rightStyleInside = {position:'relative', backgroundColor:'#CCC', verticalAlign:'top', overflow:'hidden', zoom:scale, mozTransform:'scale(' + scale + ')', msZoom:scale, webkitZoom:scale, zIndex:0, height:sHeight, width:sWidth};

  function onMouseDown(e){
    setBaselineMousePosition({currentX:e.clientX, currentY:e.clientY, where:'dragScreen'});
  }


  function onMouseMove(e){
    if (baselineMousePosition){
      var newX = e.clientX;
      var newY = e.clientY;
      var origX = baselineMousePosition.currentX;
      var origY = baselineMousePosition.currentY;
      if (baselineMousePosition.where === 'dragScreen'){
        setTranslateX(translateX + (newX - origX) / scale);
        setTranslateY(translateY + (newY - origY) / scale);
        setBaselineMousePosition({currentX:newX, currentY:newY, where:baselineMousePosition.where});        
      }else if (baselineMousePosition.where === 'dragMove'){

        var isFEOrPU = baselineMousePosition.isFEOrPU;
        var aFEKey = baselineMousePosition.aFEKey;
        var down = [isFEOrPU, aFEKey, 'pos'];
        var pos = CoreFns.goDownPath(currentListX, down);
        var newPosX = pos.xP + (newX - origX) / (1.1 * insetWidth * scale);
        var newPosY = pos.yP + (newY - origY) / (1.1 * insetHeight * scale);
        var changes = [{t:'w', w:down, n:{xP:newPosX, yP:newPosY}}];
        organicChanges(changes);
        setBaselineMousePosition({currentX:newX, currentY:newY, where:baselineMousePosition.where, isFEOrPU, aFEKey});        
      }


    }
  }

  var editSet = <div style={rightStyleOut} ref={scrollableElement}>
        <div style={rightStyleInside}>
          {screenPieces}          
        </div>
        </div>

  if (feKeys.length === 0){
    editSet = <div style={{width:'100%', padding:'10px'}}><center><p className='lead mb-0'>All dApps must have at least one page.</p><button className='btn btn-secondary' onClick={addFE('fe')} style={{marginTop:'20px', marginBottom:'20px'}}>+ Page</button>
    </center></div>
  }


//  
  return (
    <table style={{width, height, borderCollapse:'collapse'}} className='noSelect'><tbody>
    <tr className='noSelect'>
      <td style={{verticalAlign:'top', width:tabWidth, backgroundColor:selectedColor, zIndex:1, position:'relative'}} className='noBorder '>
        <div style={{height, overflowY:'scroll', backgroundColor:'#111'}}>
          <table style={{borderCollapse:'collapse', backgroundColor:'#444'}}><tbody>
            {elementRows}
          </tbody></table>
        </div>
      </td>
      {tabDetails0}
      <td style={{position:'relative', backgroundColor:'#CCC'}} className='noBorder' onClick={clickBackground} onMouseDown={onMouseDown} onMouseMove={onMouseMove} ref={pageRef}>
        {removeShrink}
        {editSet}
      </td>
    </tr>
    </tbody></table>
  );
}

function getElementFromEntity(entityId){
  return document.getElementById(entityId);
}

export default App;
